"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _singleInstance = _interopRequireDefault(require("../core/singleInstance"));
var _tool = require("@entrylabs/tool");
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _view = /*#__PURE__*/new WeakMap();
var _dropper = /*#__PURE__*/new WeakMap();
var _DropperExtension_brand = /*#__PURE__*/new WeakSet();
var DropperExtension = /*#__PURE__*/(0, _createClass2["default"])(function DropperExtension() {
  (0, _classCallCheck2["default"])(this, DropperExtension);
  _classPrivateMethodInitSpec(this, _DropperExtension_brand);
  _classPrivateFieldInitSpec(this, _view, null);
  _classPrivateFieldInitSpec(this, _dropper, null);
  return _assertClassBrand(_DropperExtension_brand, this, _createView).call(this);
});
function _createView() {
  _classPrivateFieldSet(_view, this, Entry.Dom('div', {
    "class": 'entryDropper',
    parent: $('.entryExtension')
  }));
  _classPrivateFieldSet(_dropper, this, new _tool.Dropper({
    isShow: false,
    container: _classPrivateFieldGet(_view, this)[0]
  }));
  return _classPrivateFieldGet(_dropper, this);
}
var _default = exports["default"] = (0, _singleInstance["default"])(DropperExtension);